/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */
import React, { Component }  from "react";
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import messages from './messages';

const styles = {
    privacyLink: {
        color: '#FFFFFF',
    },
    privacyPolicyDiv: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        padding: '1.5em'
    }
}

export class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div style={styles.privacyPolicyDiv}>
        <a target='_blank' href="https://www.lifesize.com/en/legal-notices/cxengage-privacy-policy/" style={styles.privacyLink}>
          <FormattedMessage {...messages.privacyPolicy} />
        </a>
      </div>
    );
  }
}

PrivacyPolicy.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(PrivacyPolicy);